import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

const Login = () => {
  const { login, user, loading, error, clearError } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || '/';

  const [form, setForm] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (user) navigate(from, { replace: true });
    return () => clearError();
  }, [user]);

  const handleChange = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    await login(form.email, form.password);
  };

  const fillDemo = () => setForm({ email: 'kalpana@demo.com', password: 'kalpana123' });
  const fillAdmin = () => setForm({ email: 'admin@roamio.com', password: 'admin123' });

  return (
    <div className="auth-page">
      <div className="auth-left">
        <img src="https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=900" alt="Luxury hotel" />
        <div className="auth-left-overlay" />
        <div className="auth-left-content">
          <Link to="/" className="auth-logo">
            <span className="logo-icon"><i className="fa-solid fa-feather-pointed logo-icon"></i></span>
            <span>Roamio</span>
          </Link>
          <blockquote className="auth-quote">
            "The world is a book, and those who do not travel read only one page."
            <cite>— Saint Augustine</cite>
          </blockquote>
        </div>
      </div>

      <div className="auth-right">
        <div className="auth-form-wrap">
          <div className="auth-header">
            <h2>Welcome back</h2>
            <p>Sign in to access your bookings and discover new stays</p>
          </div>

          {error && <div className="alert alert-error">{error}</div>}

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label className="form-label">Email Address</label>
              <input
                type="email"
                name="email"
                className="form-input"
                placeholder="you@example.com"
                value={form.email}
                onChange={handleChange}
                required
                autoComplete="email"
              />
            </div>

            <div className="form-group">
              <label className="form-label">Password</label>
              <div className="password-wrap">
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  className="form-input"
                  placeholder="Your password"
                  value={form.password}
                  onChange={handleChange}
                  required
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <i className="fa-solid fa-lock"></i> : <i className="fa-solid fa-eye"></i>}
                </button>
              </div>
            </div>

            <button type="submit" className="btn btn-primary btn-lg auth-submit" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In →'}
            </button>
          </form>

          <div className="auth-demo">
            <p className="demo-label">Try demo accounts:</p>
            <div className="demo-btns">
              <button className="demo-btn" onClick={fillDemo}><i className="fa-solid fa-user-tag"></i> Demo User</button>
              <button className="demo-btn" onClick={fillAdmin}><i className="fa-solid fa-key"></i> Admin</button>
            </div>
          </div>

          <div className="auth-divider"><span>New to Roamio?</span></div>

          <Link to="/register" className="btn btn-outline btn-lg auth-alt-btn">
            Create a Free Account
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
